import { ResultsFetchError } from './results-fetch-error';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ResultsFetchError } from './results-fetch-error';
export class EmptyEntitiesError extends ResultsFetchError {
	constructor() {
		super('No entities provided to fetch results');
		this.name = 'EmptyEntitiesError';
	}
}
